export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "nakshatra": "ನಕ್ಷತ್ರವನ್ನು ಅನ್ವೇಷಿಸಿ",
    "birth_star_analysis": "ಜನ್ಮ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆ",
    "nakshatra_description": "ನಕ್ಷತ್ರವು ಕ್ರಾಂತಿವೃತ್ತದ ಉದ್ದಕ್ಕೂ ಇರುವ ೨೭ ಚಂದ್ರ ಮಂಜಿಲುಗಳಲ್ಲಿ ಒಂದಾಗಿದ್ದು, ಪ್ರತಿಯೊಂದನ್ನು ನಾಲ್ಕು ಪಾದಗಳಾಗಿ (ಭಾಗಗಳು) ವಿಭಜಿಸಲಾಗಿದೆ. ಪ್ರತಿ ಪಾದವು ನಿರ್ದಿಷ್ಟ ಅಕ್ಷರಗಳೊಂದಿಗೆ ಸಂಬಂಧ ಹೊಂದಿದೆ, ಇದನ್ನು ಚಂದ್ರನ ಸ್ಥಾನದ ಆಧಾರದ ಮೇಲೆ ನವಜಾತ ಶಿಶುವಿನ ಹೆಸರನ್ನು ಆಯ್ಕೆ ಮಾಡಲು ಬಳಸಲಾಗುತ್ತದೆ.",

    // Service Information
    "enter_birth_details": "ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_nakshatra_analysis": "ಸಂಪೂರ್ಣ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_nakshatra_analysis_note": "ವ್ಯಕ್ತಿತ್ವ, ಸಂಬಂಧಗಳು ಮತ್ತು ಜೀವನ ಮಾರ್ಗದ ಮೇಲೆ ನಿಮ್ಮ ಜನ್ಮ ನಕ್ಷತ್ರದ ಪ್ರಭಾವದ ಆಳವಾದ ಅಧ್ಯಯನ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_critical_for_nakshatra": "ನಿಖರವಾದ ನಕ್ಷತ್ರ ಗುರುತಿಸುವಿಕೆಗಾಗಿ ನಿಖರವಾದ ಜನ್ಮ ಸಮಯ ಅತ್ಯಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ನಿಮ್ಮ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗುವುದು",

    // Core Nakshatra Features
    "birth_star_identification": "ಜನ್ಮ ನಕ್ಷತ್ರ ಗುರುತಿಸುವಿಕೆ",
    "personality_traits_detailed": "ವಿಸ್ತೃತ ವ್ಯಕ್ತಿತ್ವ ಮತ್ತು ಪಾತ್ರ ವಿಶ್ಲೇಷಣೆ",
    "compatibility_analysis": "ವಿವಾಹ ಮತ್ತು ಸಂಬಂಧ ಹೊಂದಾಣಿಕೆ",
    "career_guidance_nakshatra": "ಜನ್ಮ ನಕ್ಷತ್ರದ ಆಧಾರದ ಮೇಲೆ ವೃತ್ತಿ ಮಾರ್ಗ",
    "lucky_elements": "ಅದೃಷ್ಟದ ಬಣ್ಣಗಳು, ಸಂಖ್ಯೆಗಳು ಮತ್ತು ರತ್ನಗಳು",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆಯಲ್ಲಿ ಏನು ಸೇರಿದೆ",
    "your_birth_star_detailed": "ನಿಮ್ಮ ಜನ್ಮ ನಕ್ಷತ್ರದ ವಿವರವಾದ ವಿವರಣೆ",
    "nakshatra_characteristics": "ಮೂಲ ನಕ್ಷತ್ರ ಗುಣಲಕ್ಷಣಗಳು",
    "pada_analysis": "ಪಾದ (ಭಾಗ) ವಿಶ್ಲೇಷಣೆ",
    "ruling_deity_insights": "ಅಧಿಪತಿ ದೇವತೆ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಒಳನೋಟಗಳು",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆ ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆ ರಚಿಸುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "nakshatra_analysis_processing": "ನಿಮ್ಮ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ಪರಿಣಿತ ವೈದಿಕ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನಿಮ್ಮ ಜನ್ಮ ನಕ್ಷತ್ರದ ಪ್ರಭಾವದ ಬಗ್ಗೆ ಆಳವಾದ ಒಳನೋಟಗಳನ್ನು ನೀವು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_12_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ನಕ್ಷತ್ರ ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತಕ್ಷಣ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಕಳುಹಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_nakshatra_report": "ಸಮಗ್ರ ನಕ್ಷತ್ರ ವರದಿ (PDF)",
    "birth_star_characteristics": "ಜನ್ಮ ನಕ್ಷತ್ರ ವ್ಯಕ್ತಿತ್ವ ಪ್ರೊಫೈಲ್",
    "pada_and_symbol_analysis": "ಪಾದ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಪವಿತ್ರ ಚಿಹ್ನೆಗಳು",
    "compatibility_insights": "ವಿವಾಹ ಮತ್ತು ಪಾಲುದಾರಿಕೆ ಹೊಂದಾಣಿಕೆ",
    "lucky_colors_numbers": "ಅದೃಷ್ಟದ ಅಂಶಗಳು ಮತ್ತು ಪರಿಹಾರಾತ್ಮಕ ರತ್ನಗಳು",

    // Visual Content
    "sample_nakshatra_analysis": "ಮಾದರಿ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆ",
    "sample_nakshatra_description": "ವಿಸ್ತೃತ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಜನ್ಮ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "popular_nakshatras": "೨೭ ನಕ್ಷತ್ರಗಳು",

    // Major Nakshatra Names
    "ashwini": "ಅಶ್ವಿನಿ - ಅಶ್ವಾರೋಹಿಗಳು",
    "bharani": "ಭರಣಿ - ಭರಿಸುವವರು",
    "kritika": "ಕೃತಿಕಾ - ಕತ್ತರಿಸುವವರು",
    "rohini": "ರೋಹಿಣಿ - ಕೆಂಪು ಬಣ್ಣದವಳು",
    "mrigashira": "ಮೃಗಶಿರ - ಜಿಂಕೆಯ ತಲೆ",
    "ardra": "ಆರ್ದ್ರ - ತೇವವಾದದ್ದು",
    "punarvasu": "ಪುನರ್ವಸು - ಪುನಃಸ್ಥಾಪಕ",
    "pushya": "ಪುಷ್ಯ - ಪೋಷಕ",
    "ashlesha": "ಆಶ್ಲೇಷ - ಆಲಿಂಗನ ಮಾಡುವವರು",
    "magha": "ಮಘ - ಶಕ್ತಿಶಾಲಿ",
    "purva_phalguni": "ಪೂರ್ವ ಫಾಲ್ಗುನಿ",
    "uttara_phalguni": "ಉತ್ತರ ಫಾಲ್ಗುನಿ",

    // Status & Processing
    "your_nakshatra_analysis_status": "ನಿಮ್ಮ ನಕ್ಷತ್ರ ವಿಶ್ಲೇಷಣೆ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ಜನ್ಮ ನಕ್ಷತ್ರವನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ ಪರಿಣಿತರು ನಿಮ್ಮ ನಕ್ಷತ್ರದ ಕಾಸ್ಮಿಕ್ ಪ್ರಭಾವಗಳನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ ಮತ್ತು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಒಳನೋಟಗಳನ್ನು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸರದಿಯಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_12_hours": "ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಜ್ಯೋತಿಷ್ಯ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಜನ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಸಂಸ್ಕರಣೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Nakshatra-Specific Elements
    "birth_star": "ಜನ್ಮ ನಕ್ಷತ್ರ",
    "nakshatra_lord": "ನಕ್ಷತ್ರ ಅಧಿಪತಿ",
    "ruling_planet": "ಆಡುಭಟ್ಟ ಗ್ರಹ",
    "nakshatra_symbol": "ಪವಿತ್ರ ಚಿಹ್ನೆ",
    "presiding_deity": "ಅಧಿಷ್ಠಾನ ದೇವತೆ",
    "gana_type": "ಗಣ ವರ್ಗೀಕರಣ",
    "nakshatra_nature": "ಅಂತರ್ಗತ ಸ್ವಭಾವ",
    "power_animal": "ಶಕ್ತಿ ಪ್ರಾಣಿ",

    // Pada (Quarters) Analysis
    "pada_1": "ಮೊದಲ ಪಾದ (0°-3°20')",
    "pada_2": "ಎರಡನೇ ಪಾದ (3°20'-6°40')",
    "pada_3": "ಮೂರನೇ ಪಾದ (6°40'-10°)",
    "pada_4": "ನಾಲ್ಕನೇ ಪಾದ (10°-13°20')",
    "your_pada": "ನಿಮ್ಮ ನಕ್ಷತ್ರ ಪಾದ",
    "pada_characteristics": "ಪಾದ-ವಿಶಿಷ್ಟ ಲಕ್ಷಣಗಳು",
    "pada_influence": "ನಿಮ್ಮ ಪಾದ ನಿಮ್ಮನ್ನು ಹೇಗೆ ರೂಪಿಸುತ್ತದೆ",

    // Personality & Character
    "core_personality": "ಮೂಲ ವ್ಯಕ್ತಿತ್ವ ಗುಣಗಳು",
    "strengths_weaknesses": "ಶಕ್ತಿಗಳು ಮತ್ತು ಬೆಳವಣಿಗೆಯ ಕ್ಷೇತ್ರಗಳು",
    "mental_nature": "ಮಾನಸಿಕ ಪ್ರವೃತ್ತಿ",
    "emotional_patterns": "ಭಾವನಾತ್ಮಕ ಮಾದರಿಗಳು",
    "behavioral_tendencies": "ನಡವಳಿಕೆಯ ಪ್ರವೃತ್ತಿಗಳು",
    "life_approach": "ಜೀವನದ ವಿಧಾನ",

    // Compatibility & Relationships
    "compatible_nakshatras": "ಹೆಚ್ಚು ಹೊಂದಾಣಿಕೆಯ ಜನ್ಮ ನಕ್ಷತ್ರಗಳು",
    "challenging_nakshatras": "ಸಂಭಾವ್ಯ ಸವಾಲಿನ ಹೊಂದಾಣಿಕೆಗಳು",
    "marriage_compatibility": "ವಿವಾಹ ಮತ್ತು ಪಾಲುದಾರಿಕೆ ವಿಶ್ಲೇಷಣೆ",
    "friendship_compatibility": "ಸ್ನೇಹ ಡೈನಾಮಿಕ್ಸ್",
    "business_partnership": "ವ್ಯಾಪಾರ ಸಹಯೋಗ ಸಾಮರ್ಥ್ಯ",
    "relationship_advice": "ಸಂಬಂಧ ಮಾರ್ಗದರ್ಶನ",

    // Career & Profession
    "suitable_careers": "ಆದರ್ಶ ವೃತ್ತಿ ಮಾರ್ಗಗಳು",
    "professional_strengths": "ವೃತ್ತಿಪರ ಶಕ್ತಿಗಳು",
    "work_environment": "ಅತ್ಯುತ್ತಮ ಕೆಲಸದ ವಾತಾವರಣ",
    "leadership_style": "ನಾಯಕತ್ವ ವಿಧಾನ",
    "business_prospects": "ಉದ್ಯಮಶೀಲತೆಯ ಸಾಮರ್ಥ್ಯ",
    "financial_tendencies": "ಹಣ ನಿರ್ವಹಣೆ ಶೈಲಿ",

    // Health & Wellness
    "health_tendencies": "ಆರೋಗ್ಯ ಪ್ರವೃತ್ತಿಗಳು",
    "vulnerable_areas": "ಗಮನ ಅಗತ್ಯವಿರುವ ಕ್ಷೇತ್ರಗಳು",
    "wellness_recommendations": "ಆರೋಗ್ಯ ಮತ್ತು ಕಲ್ಯಾಣ ಸಲಹೆಗಳು",
    "dietary_guidance": "ಆಹಾರ ಶಿಫಾರಸುಗಳು",

    // Spiritual & Remedial
    "spiritual_path": "ಆಧ್ಯಾತ್ಮಿಕ ಪ್ರಯಾಣ",
    "life_purpose": "ಆತ್ಮದ ಉದ್ದೇಶ",
    "karmic_lessons": "ಜೀವನ ಪಾಠಗಳು",
    "recommended_remedies": "ವೈದಿಕ ಪರಿಹಾರಗಳು",
    "mantras_to_chant": "ಪ್ರಯೋಜನಕಾರಿ ಮಂತ್ರಗಳು",
    "meditation_practices": "ಧ್ಯಾನ ತಂತ್ರಗಳು",
    "worship_recommendations": "ದೇವತಾ ಪೂಜೆ ಮಾರ್ಗದರ್ಶನ",
    "fasting_days": "ಶುಭ ಉಪವಾಸ ದಿನಗಳು",
    "donation_suggestions": "ದಾನಧರ್ಮ ಚಟುವಟಿಕೆಗಳು",

    // Lucky Elements
    "lucky_colors": "ಶುಭ ಬಣ್ಣಗಳು",
    "lucky_numbers": "ಅನುಕೂಲ ಸಂಖ್ಯೆಗಳು",
    "lucky_days": "ವಾರದ ಉತ್ತಮ ದಿನಗಳು",
    "lucky_directions": "ಅನುಕೂಲ ದಿಕ್ಕುಗಳು",
    "lucky_gemstones": "ಪ್ರಯೋಜನಕಾರಿ ರತ್ನಗಳು",
    "lucky_metals": "ಶುಭ ಲೋಹಗಳು",
    "favorable_timing": "ಪ್ರಮುಖ ಚಟುವಟಿಕೆಗಳಿಗೆ ಅತ್ಯುತ್ತಮ ಸಮಯ",

    // Detailed Analysis Sections
    "nakshatra_mythology": "ಪೌರಾಣಿಕ ಹಿನ್ನೆಲೆ",
    "cosmic_connection": "ಕಾಸ್ಮಿಕ್ ಮಹತ್ವ",
    "elemental_influence": "ಮೂಲ ಅಂಶಗಳ ಸಂಬಂಧಗಳು",
    "seasonal_connection": "ಋತುವಿನ ಪ್ರಭಾವ",
    "lunar_mansion": "ಚಂದ್ರ ಮಂಜಿಲಿನ ಮಹತ್ವ",
    "vedic_wisdom": "ಪ್ರಾಚೀನ ವೈದಿಕ ಒಳನೋಟಗಳು"
};
